"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixUnderline = fixUnderline;
const tex_syntax_1 = require("./tex-syntax");
const underlineWithMissingBraces = new RegExp(`(\\\\underline)(\\\\(?:${tex_syntax_1.color}|text)${(0, tex_syntax_1.arg)(2)})`, "g");
function fixUnderline(tex) {
    return tex.replace(underlineWithMissingBraces, "$1{$2}");
}
